module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/parma.3ddb6b51bd26bdd29185c8d7c5e26585.jpg";